export const exportHeaders = [
    // {
    //     label: "MPC ID",
    //     key: "product_primary_class_id"
    // },
    // {
    //     label: "MPC Description",
    //     key: "product_primary_class_description",
    // },
    // {
    //     label: "Major Class Code",
    //     key: "primary_major_class_code",
    // },
    // {
    //     label: "Major Class Code Description",
    //     key: "primary_major_class_code_description",
    // },
    // {
    //     label: "Sub Major Class Code",
    //     key: "primary_submajor_class_code",
    // },
    // {
    //     label: "Sub Major Class Code Description",
    //     key: "primary_submajor_class_code_description",
    // },
    // {
    //     label: "Minor Class Code",
    //     key: "primary_minor_class_code",
    // },
    // {
    //     label: "Minor Class Code Description",
    //     key: "primary_minor_class_code_description",
    // },
    // {
    //     label: "Sales Category",
    //     key: "loyalty_category_code"
    // },
    // {
    //     label: "Redemption %",
    //     key: "redemption_percentage"
    // },
    // {
    //     label: "Status",
    //     key: "is_active"
    // },
    // {
    //     label: "Org name",
    //     key: "loyalty_organization_name"
    // },
    // {
    //     label: "Site Name",
    //     key: "loyalty_site_id"
    // },

        {
            label: "Id",
            key: "id"
        },

        {
            label: "Tier",
            key: "tier"
        },

        {
            label:"Tier Start Value",
            key: "tier_start_value"
        },

        {
            label:"Tier End Value",
            key: "tier_end_value"
        },

        {
            label:"Tier Ratio",
            key: "tier_ratio"
        },

        {
            label:"Loyalty Site Id",
            key: "loyalty_site_id"
        },

        {
            label:"Loyalty Category Code",
            key: "loyalty_category_code"
        },

        {
            label:"Label Class Code",
            key: "label_class_code"
        },

        {
            label:"Label Class Code Description",
            key: "label_class_code_description"
        }

]